import { DatePicker, ModalProps, styled } from '@attentive-platform/stem-ui';
import { useState } from 'react';
import { Modal } from '../Modal';
import { modalHeading } from './styles';
import { Input } from '../Input';

const StyledInput = styled(Input)(() => ({
  '& .MuiInputBase-root': {
    height: '2.375rem'
  }
}));

const StyledDatePicker = styled(DatePicker)(() => ({
  width: '100%',
  marginTop: '0.25rem',
  '& .MuiInputBase-root': {
    height: '2.375rem'
  }
}));

type EstHoursModalProps = {
  show: boolean;
  onClose: () => void;
  start: string;
  end: string;
  hours: number;
  onSave: (val: { startDate: string; endDate: string; estHours: number }) => void;
};

export const EstHoursModal = ({ show, onClose, start, end, hours, onSave }: EstHoursModalProps) => {
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [estHours, setEstHours] = useState(`${Math.floor(hours / 60)}`);
  const [estMin, setEstMin] = useState(`${hours % 60}`);
  const [isError, setIsError] = useState(false);

  const handleSave = () => onSave({ startDate, endDate, estHours: Number(estHours) * 60 + Number(estMin) });

  const handleInput = (val: string, key: 'hours' | 'mins') => {
    if (!Number.isNaN(+val)) {
      if (key === 'hours') setEstHours(val);
      else setEstMin(val);
      setIsError(false);
    } else {
      setIsError(true);
    }
  };

  const ctas: ModalProps['ctas'] = {
    primary: {
      label: 'Done',
      variant: 'outlined',
      color: 'primary',
      size: 'medium',
      onClick: handleSave,
      disabled: isError
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      showCloseIcon={false}
      content={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div className={modalHeading}>Add your estimate hours</div>
          <div>
            <div>Enter start date</div>
            <StyledDatePicker value={startDate} onChange={setStartDate} restrictInputTyping />
          </div>
          <div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <StyledInput
                placeholder='Hrs'
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInput(e.target.value, 'hours')}
                value={estHours}
              />
              <StyledInput
                placeholder='Min'
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInput(e.target.value, 'mins')}
                value={estMin}
              />
            </div>
            {isError && <div style={{ color: 'red', fontSize: '0.625rem' }}>* Please enter numeric values</div>}
          </div>
          <div>
            <div>Enter end date</div>
            <StyledDatePicker value={endDate} onChange={setEndDate} restrictInputTyping minDate={startDate} />
          </div>
        </div>
      }
      ctas={ctas}
      zIndex={1200}
      ctasStyle={{ marginTop: '1.5rem' }}
      PaperProps={{
        style: {
          padding: '0.5rem',
          borderRadius: '0.5rem'
        }
      }}
      maxWidth='xl'
    />
  );
};
